import * as React from 'react';
import {OnPremisePage} from 'src/components/pages/pricing/OnPremisePage';
import {PricingPage2} from "src/components/pages/home2/PricingPage2";

// export default () => <OnPremisePage/>;
export default () => <PricingPage2/>;
